import { render, staticRenderFns } from "./services-settings.vue?vue&type=template&id=03e63b4b"
import script from "./services-settings.vue?vue&type=script&lang=js"
export * from "./services-settings.vue?vue&type=script&lang=js"
import style0 from "./services-settings.vue?vue&type=style&index=0&id=03e63b4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports